import api from "../../api";
import type { StoriesPage, StoryContent } from "../../../@types/portalAluno";
import { PORTAL_STORIES_PAGE_SIZE } from "../../../config/portalAluno/constants";
import {
  mapApiStories,
  mapApiStoryContents,
} from "../../../utils/portalAluno/mappers/storyMapper";

export const getStoriesPage = async (offset: number): Promise<StoriesPage> => {
  const response = await api.get("mobile/storys", {
    params: { offset, limite: PORTAL_STORIES_PAGE_SIZE },
  });

  const stories = mapApiStories(response.data);

  return {
    itemCount: Array.isArray(response.data) ? response.data.length : 0,
    stories,
  };
};

export const getStoryContents = async (
  storyId: number
): Promise<StoryContent[]> => {
  const response = await api.get("mobile/story-conteudo", {
    params: { idStory: storyId },
  });

  return mapApiStoryContents(response.data);
};

export const registerStoryContentView = async (
  storyContentId: number
): Promise<void> => {
  await api.post("mobile/visualizar-story-conteudo", null, {
    params: { idStoryConteudo: storyContentId },
  });
};

export const toggleStoryContentLike = async (
  storyContentId: number
): Promise<void> => {
  await api.post("mobile/curtir-story-conteudo", null, {
    params: { idStoryConteudo: storyContentId },
  });
};
